export default __webpack_public_path__ + "static/media/tempestofset_color.6859ce07.png";